/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('figures.ticker', function (el) {
        var EL_NAME = '.hasTicker';
        var IN_VIEW_OFFSET_DESKTOP = 70;
        var IN_VIEW_OFFSET_MOBILE = 0;
        var elements = document.querySelectorAll(EL_NAME);
        if (!elements.length) {
            return;
        }
        var init = function () {
            window.onscroll = function () {
                elements.forEach(function (el) {
                    if (!el.classList.contains('done') && isInView(el)) {
                        countUp(el);
                        el.classList.add('done');
                    }
                });
            };
            window.dispatchEvent(new Event('scroll'));
        };
        var isInView = function (elem) {
            var offset = window.innerWidth >= 992 ? IN_VIEW_OFFSET_DESKTOP : IN_VIEW_OFFSET_MOBILE;
            var bounding = elem.getBoundingClientRect();
            return (bounding.top >= 0 && bounding.left >= 0
                && bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) - offset);
        };
        var countUp = function (el) {
            var start;
            var number = el.getAttribute('data-number');
            var final = parseInt(number);
            var sfx = number.replace(final.toString(), '');
            var duration = 1500;
            var step = function (ts) {
                if (!start) {
                    start = ts;
                }
                var progress = (ts - start) / duration;
                var value = Math.ceil(progress * final);
                if (final > 0) {
                    el.textContent = (value < final ? value + sfx : number);
                }
                else {
                    el.textContent = (value > final ? value + sfx : number);
                }
                if (progress < 1) {
                    requestAnimationFrame(step);
                }
            };
            requestAnimationFrame(step);
        };
        init();
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
